export enum RequestType {
    ADVANCE_NOTIFICATION = 'advanceNotification',
    CERTIFICATION_REQUEST = 'certificationRequest'
}

export const REQUEST_TYPE_NAMES: Record<RequestType, string> = {
    [RequestType.ADVANCE_NOTIFICATION]: $localize`:@@requestType.advanceNotification:Vorabmeldung`,
    [RequestType.CERTIFICATION_REQUEST]: $localize`:@@requestType.certificationRequest:Zertifizierungsanfrage`,
};
